import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Button,
    Box,
    IconButton,
    TextField
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';

interface AppointmentsSettingsTabProps {
    hygieneServiceTypes: string[];
    onAddServiceType: () => void;
    onRemoveServiceType: (index: number) => void;
    onUpdateServiceType: (index: number, value: string) => void;
}

export const AppointmentsSettingsTab: React.FC<AppointmentsSettingsTabProps> = ({
    hygieneServiceTypes,
    onAddServiceType,
    onRemoveServiceType,
    onUpdateServiceType
}) => {
    return (
        <Card>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6">
                        Hygiene Service Types
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={onAddServiceType}
                    >
                        Add Service Type
                    </Button>
                </Box>

                {hygieneServiceTypes.map((serviceType, index) => (
                    <Box key={index} sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <TextField
                                fullWidth
                                label={`Service Type ${index + 1}`}
                                value={serviceType}
                                onChange={(e) => onUpdateServiceType(index, e.target.value)}
                                placeholder="Enter hygiene service type"
                            />
                            <IconButton
                                color="error"
                                onClick={() => onRemoveServiceType(index)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    </Box>
                ))}

                {hygieneServiceTypes.length === 0 && (
                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
                        No hygiene service types added yet. Click "Add Service Type" to get started.
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
};
